import { render, staticRenderFns } from "./board-actions-dropdown.vue?vue&type=template&id=a5b510c6"
import script from "./board-actions-dropdown.vue?vue&type=script&lang=js"
export * from "./board-actions-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports